import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const NAV_ITEMS = [
  { label: "首頁", to: "/" },
  { label: "關於文彰", to: "/about" },
  { label: "幸福人才系統", to: "/happiness-talent-system" },
  { label: "個人成長", to: "/personal-growth" },
  { label: "企業培訓", to: "/corporate-training" },
  { label: "課程活動", to: "/courses" },
  { label: "聯絡／合作", to: "/contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  const isActive = (to: string) =>
    to === "/" ? pathname === "/" : pathname.startsWith(to);

  return (
    <header
      className={`sticky top-0 z-50 bg-cream border-b border-line transition-shadow duration-300 ${
        scrolled ? "shadow-[0_1px_12px_rgba(29,41,53,0.06)]" : ""
      }`}
    >
      <div className="mx-auto max-w-container-wide px-4 md:px-6">
        <div className="flex items-center justify-between h-16 lg:h-20">
          {/* Brand */}
          <Link to="/" className="flex flex-col leading-none cursor-pointer">
            <span className="text-lg lg:text-xl font-bold text-primary">
              幸福人才
            </span>
            <span className="mt-1 text-[11px] lg:text-xs text-ink-soft tracking-wide">
              許文彰 Wen-Chang Hsu
            </span>
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-7">
            {NAV_ITEMS.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`relative whitespace-nowrap text-[15px] font-medium cursor-pointer transition-colors duration-200 ${
                  isActive(item.to)
                    ? "text-primary font-semibold"
                    : "text-ink-soft hover:text-primary"
                }`}
              >
                {item.label}
                {isActive(item.to) && (
                  <span className="absolute -bottom-1.5 left-0 right-0 h-[2px] bg-gold rounded-full"></span>
                )}
              </Link>
            ))}
          </nav>

          {/* Desktop CTA */}
          <div className="hidden lg:block">
            <Link
              to="/ai-coach"
              className="inline-flex items-center gap-2 rounded-md bg-gold px-5 py-2.5 text-sm font-semibold text-white whitespace-nowrap cursor-pointer transition-colors duration-300 hover:bg-gold/90"
            >
              <i className="ri-sparkling-2-line text-base leading-none" aria-hidden="true"></i>
              AI 幸福人才顧問
            </Link>
          </div>

          {/* Mobile Hamburger */}
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden w-10 h-10 flex items-center justify-center text-primary cursor-pointer"
            aria-label="開啟選單"
          >
            <i
              className={`${open ? "ri-close-line" : "ri-menu-line"} text-2xl`}
              aria-hidden="true"
            ></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`lg:hidden fixed inset-x-0 top-16 bottom-0 z-40 bg-cream transition-opacity duration-300 ${
          open ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
        }`}
      >
        <nav className="px-6 py-6 flex flex-col gap-1">
          {NAV_ITEMS.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`py-3 border-b border-line text-base font-medium cursor-pointer transition-colors ${
                isActive(item.to) ? "text-primary font-semibold" : "text-ink-soft"
              }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>
        <div className="px-6 mt-6">
          <Link
            to="/ai-coach"
            className="flex items-center justify-center gap-2 rounded-md bg-gold px-5 py-3.5 text-base font-semibold text-white cursor-pointer transition-colors duration-300 hover:bg-gold/90"
          >
            <i className="ri-sparkling-2-line text-base leading-none" aria-hidden="true"></i>
            AI 幸福人才顧問
          </Link>
        </div>
      </div>
    </header>
  );
}